import React, {useState} from 'react';
import styled from 'styled-components';
import {Card, Collapse, Rate, Typography} from 'antd';
import candidatesImg from "../../assets/candPersons.png"
import {useNavigate} from 'react-router-dom';
import {Briefcase, GraduationCap, Calculator, Crown, Envelope, Exam, Minus, PenNib, Plus, UserCircle} from '@phosphor-icons/react';
import {colors} from '../../util/colors';
import heroImage from '../../assets/silverplus.jpg';
import {SilverButton} from "../../components/LayoutWrapperCandidate";
import {Testimonials} from "./Testimonials";

const {Title, Paragraph, Text} = Typography;
const {Panel} = Collapse;

interface ISilverPlus {
}

export const SilverPlus: React.FC<ISilverPlus> = () => {
    const [activeKey, setActiveKey] = useState<string | string[]>([]);
    const navigate = useNavigate();

    const benefits = [
        {
            icon: <GraduationCap size={32} weight="fill"/>,
            title: "Online-Kurse",
            description: "Lebenslang lernen: Eignen Sie sich neues Wissen und Fähigkeiten an mit unseren Online-Kursen speziell für Ü60 - nur mit silver+.",
            color: "#4F46E5"
        },
        {
            icon: <Envelope size={32} weight="fill"/>,
            title: "Oben im Postfach",
            description: "Mehr gesehen werden: Mit silver+ landen Ihre Nachrichten an Arbeitgeber immer oben in deren silvertalent Postfach.",
            color: "#4F46E5"
        },
        {
            icon: <Briefcase size={32} weight="fill"/>,
            title: "Mehr Jobs",
            description: "Mehr sehen: Erhalten Sie Zugang zur größten Auswahl an Ü60 & Teilzeit Jobs mit der neuen KI Jobsuche - exklusiv als silver+ Mitglied.",
            color: "#00a9b2"
        },
        {
            icon: <PenNib size={32} weight="fill"/>,
            title: "Anschreiben-Hilfe",
            description: "Schneller bewerben: Als Mitglied von silver+ können Sie von uns personalisierte Anschreiben für Ihre Bewerbungen erstellen lassen.",
            color: "#10B981"
        },
        {
            icon: <Exam size={32} weight="fill"/>,
            title: "Interview-Vorbereitung",
            description: "Souveräner auftreten: Mit silver+ können Sie sich mit Hilfe unseres Interview-Trainers optimal auf Bewerbungsgespräche vorbereiten.",
            color: "#F59E0B"
        },
        {
            icon: <UserCircle size={32} weight="fill"/>,
            title: "persönlicher Jobcoach",
            description: "Potenziale entdecken: Unser digitaler Jobcoach findet mit Ihnen heraus, welche Fähigkeiten in Ihnen stecken, und welche Tätigkeiten zu Ihnen passen - nur mit silver+.",
            color: "#8B5CF6"
        },
        {
            icon: <Calculator size={32} weight="fill"/>,
            title: "Rente & Steuer Ratgeber",
            description: "Endlich verstehen: Erhalten Sie mit silver+ exklusiv Zugang zu unserem digitalen Experten und endlich Klarheit zu Ihren Fragen zu Rente und Steuerthemen.",
            color: "#EF4444"
        }
    ];

    const faqItems = [
        {
            question: "Für wen ist silver+ geeignet?",
            answer: "silver+ ist für alle erfahrenen Arbeitskräfte, die gerne noch weiterarbeiten oder neue Fähigkeiten lernen wollen. Egal, ob Sie bereits Rente beziehen oder noch nicht, Voll- oder Teilzeit arbeiten wollen oder einfach nur Jobmöglichkeiten im Alter ausloten wollen. Wir unterstützen Sie im gesamten Prozess! Hierzu gehört ein Job-Finder, ein Anschreiben-Generator, ein Bewerbungsgespräch-Trainer, ein Jobcoach und Weiterbildungskurse."
        },
        {
            question: "Wieso sollte ich silver+ freischalten?",
            answer: `Sie möchten im Alter gerne weiterarbeiten, wissen aber nicht genau, welcher Job zu Ihnen passt? Dann ist silver+ genau richtig für Sie!

Sie haben viele Erfahrungen gesammelt, sind aber unsicher, wie Sie diese in einer Bewerbung am besten darstellen? Dann ist silver+ genau richtig für Sie!

Sie interessieren sich für neue Tätigkeiten oder möchten sich weiterbilden, wissen aber nicht, wo Sie anfangen sollen? Dann ist silver+ genau richtig für Sie!

Sie möchten sich im Alter beruflich neu orientieren, aber wünschen sich dabei etwas Unterstützung? Dann ist silver+ genau richtig für Sie!

silver+ ist für alle, die ihre beruflichen Möglichkeiten im Alter erkennen und nutzen möchten.
Wir sind für Sie da – mit digitalen Tools, die Sie Schritt für Schritt begleiten: vom Job-Finder bis zum Bewerbungstraining. Damit Sie das tun können, was wirklich zu Ihnen passt.`
        },
        {
            question: "Was kostet silver+?",
            answer: "Es gibt 3 unterschiedliche Optionen silver+ zu nutzen: silver+ mit 3 Monate Mindestlaufzeit kostet 19,99€ pro Monat (jetzt nur für kurze Zeit 13,99€ pro Monat), mit 6 Monate Mindestlaufzeit 13,99€ pro Monat (jetzt nur für kurze Zeit 9,99€ pro Monat) und mit 12 Monate Mindestlaufzeit 8,99€ pro Monat (jetzt nur für kurze Zeit 6,99€ pro Monat). Nach Ablauf der Mindestlaufzeit verlängert sich die silver+ Mitgliedschaft automatisch auf unbestimmte Zeit zum jeweiligen Monatspreis und ist jederzeit mit maximal 1-Monatsfrist kündbar."
        },
        {
            question: "Verlängert sich silver+ automatisch?",
            answer: "Nach Ablauf der Mindestlaufzeit verlängert sich die silver+ Mitgliedschaft automatisch auf unbestimmte Zeit zum jeweiligen Monatspreis und ist jederzeit mit maximal 1-Monatsfrist kündbar."
        },
        {
            question: "Gibt es Kündigungsfristen bzw. eine Mindestlaufzeit?",
            answer: "Es gibt 3 Optionen mit unterschiedlichen Mindestlaufzeiten: 3 Monate Mindestlaufzeit, 6 Monate Mindestlaufzeit und 12 Monate Mindestlaufzeit. Nach Ablauf der Mindestlaufzeit verlängert sich die silver+ Mitgliedschaft automatisch auf unbestimmte Zeit zum jeweiligen Monatspreis und ist jederzeit mit maximal 1-Monatsfrist kündbar."
        },
        {
            question: "Wie kann ich kündigen?",
            answer: "Sie können silver+ bequem in Ihrem silvertalent Profil kündigen."
        },
        {
            question: "Welche Zahlungsmethoden gibt es?",
            answer: "Wir akzeptieren die Zahlung mit Kreditkarte, Paypal oder Lastschrift.\n"
        },
    ];

    const handleUnlockSilverPlus = () => {
        navigate('/silverplus/subscription');
    };

    return (
        <Container>
            {/* Hero Section */}
            <HeroSection>
                <GlassBalls/>
                <HeroContent>
                    <HeroText>
                        <HeroTitle>
                            Mehr Jobs, mehr Unterstützung, mehr Erfolg
                        </HeroTitle>
                        <HeroSubtitle>
                            mit silver+ schneller zum passenden Job
                        </HeroSubtitle>
                        <BrnReviewsWrapper>
                            <SilverButton
                                type="primary"
                                size="large"
                                style={{width: 300}}
                                onClick={handleUnlockSilverPlus}
                            >
                                silver+ freischalten
                            </SilverButton>
                            <CandidatesQuotes>
                                <img src={candidatesImg} style={{height: 50}} alt=""/>
                                <RatingWrapper>
                                    <Rate disabled defaultValue={5}/>
                                    <p>
                                        47.874+ vertrauen auf silvertalent
                                    </p>
                                </RatingWrapper>

                            </CandidatesQuotes>
                        </BrnReviewsWrapper>

                    </HeroText>
                    <HeroImage>
                        <HeroImageContent>
                            <img
                                src={heroImage}
                                alt="silver+ Premium Service"
                                onError={(e) => {
                                    // Fallback if image doesn't exist
                                    const target = e.target as HTMLImageElement;
                                    target.style.display = 'none';
                                    target.nextElementSibling?.classList.remove('hidden');
                                }}
                            />
                            <ImageFallback className="hidden">
                                <Crown size={80} weight="fill"/>
                                <Text>silver+</Text>
                            </ImageFallback>
                        </HeroImageContent>
                    </HeroImage>
                </HeroContent>
            </HeroSection>

            {/* Benefits Section */}
            <Section>
                <SectionTitle>Vorteile auf einen Blick</SectionTitle>
                <BenefitsGrid>
                    {benefits.map((benefit, index) => (
                        <BenefitCard key={index}>
                            <BenefitIcon style={{color: 'black'}}>
                                {benefit.icon}
                            </BenefitIcon>
                            <BenefitTitle>{benefit.title}</BenefitTitle>
                            <BenefitDescription>{benefit.description}</BenefitDescription>
                        </BenefitCard>
                    ))}
                </BenefitsGrid>
            </Section>

            <Section>
                <SectionTitle>Deswegen vertrauen Rentner auf silver+</SectionTitle>
                <Testimonials />
            </Section>
            <CenterButton>
                <SilverButton
                    type="primary"
                    size="large"
                    onClick={handleUnlockSilverPlus}
                >
                    Jetzt silver+ freischalten
                </SilverButton>
            </CenterButton>

            <Section>
                <VideoContainer>
                    <YouTubeEmbed
                        src="https://www.youtube.com/embed/a3nuqKkEnNw"
                        title="silver+ Explainer Video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </VideoContainer>
            </Section>
            {/* FAQ Section */}
            <Section>
                <SectionTitle>Häufige Fragen zu silver+</SectionTitle>
                <FAQContainer>
                    <StyledCollapse
                        activeKey={activeKey}
                        onChange={setActiveKey}
                        expandIcon={({isActive}) =>
                            isActive ? <Minus size={16}/> : <Plus size={16}/>
                        }
                    >
                        {faqItems.map((item, index) => (
                            <StyledPanel
                                header={item.question}
                                key={index}
                            >
                                <FAQAnswer>{item.answer}</FAQAnswer>
                            </StyledPanel>
                        ))}
                    </StyledCollapse>
                </FAQContainer>
            </Section>
        </Container>
    );
};

// Styled Components
const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
`;

const HeroSection = styled.div`
    border-radius: 20px;
    padding: 60px 40px;
    margin: 0;
    color: black;
    overflow: hidden;
    position: relative;
    backdrop-filter: blur(10px);

    &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
        animation: float 8s ease-in-out infinite;
        filter: blur(20px);
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
        animation: glowPulse 6s ease-in-out infinite;
        filter: blur(15px);
    }

    @keyframes float {
        0%, 100% {
            transform: translateY(0px) rotate(0deg) scale(1);
            opacity: 0.8;
        }
        50% {
            transform: translateY(-30px) rotate(180deg) scale(1.1);
            opacity: 1;
        }
    }

    @keyframes glowPulse {
        0%, 100% {
            opacity: 0.3;
            transform: scale(1);
        }
        50% {
            opacity: 0.6;
            transform: scale(1.05);
        }
    }

    @media (max-width: 768px) {
        padding: 40px 20px;
        margin: 20px 0;
    }
`;

const GlassBalls = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.3) 0%, transparent 30%),
        radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.25) 0%, transparent 35%),
        radial-gradient(circle at 50% 10%, rgba(255, 255, 255, 0.2) 0%, transparent 25%),
        radial-gradient(circle at 10% 60%, rgba(255, 255, 255, 0.15) 0%, transparent 20%),
        radial-gradient(circle at 90% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 15%);
        animation: glassBalls 12s ease-in-out infinite;
        filter: blur(8px);
    }

    @keyframes glassBalls {
        0%, 100% {
            transform: translate(0, 0) scale(1);
            opacity: 0.4;
        }
        25% {
            transform: translate(20px, -15px) scale(1.1);
            opacity: 0.7;
        }
        50% {
            transform: translate(-10px, 20px) scale(0.9);
            opacity: 0.5;
        }
        75% {
            transform: translate(15px, 10px) scale(1.05);
            opacity: 0.6;
        }
    }
`;

const HeroContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        gap: 30px;
    }
`;

const HeroText = styled.div`
    flex: 1;
`;

const HeroTitle = styled(Title)`
    font-size: 2.5rem !important;
    font-weight: 700 !important;
    margin-bottom: 16px !important;
    line-height: 1.2 !important;

    @media (max-width: 768px) {
        font-size: 2rem !important;
    }
`;

const HeroSubtitle = styled(Paragraph)`
    font-size: 1.25rem !important;
    margin-bottom: 32px !important;
    font-weight: 400 !important;

    @media (max-width: 768px) {
        font-size: 1.1rem !important;
    }
`;

const HeroImage = styled.div`
    flex-shrink: 0;
`;

const HeroImageContent = styled.div`
    position: relative;
    width: 400px;
    height: 300px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: 200px;
    }
`;

const ImageFallback = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);

    &.hidden {
        display: none;
    }

    .ant-typography {
        color: white !important;
        font-size: 1.5rem !important;
        font-weight: 600 !important;
    }
`;

const CandidatesQuotes = styled.div`
    display: flex;
    margin-top: 16px;
    gap: 16px;
    align-items: center;
    @media (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: center;
    }
`;
const RatingWrapper = styled.div`
    display: flex;
    flex-direction: column;

    p {
        margin: 0;
    }
`;

const Section = styled.div`
    margin: 32px 0;

    @media (max-width: 768px) {
        margin: 60px 0;
    }
`;

const SectionTitle = styled(Title)`
    text-align: center !important;
    font-size: 2.5rem !important;
    font-weight: 700 !important;
    margin-bottom: 32px !important;
    color: ${colors.text} !important;

    @media (max-width: 768px) {
        font-size: 2rem !important;
        margin-bottom: 40px !important;
    }
`;

const BenefitsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
    margin-bottom: 60px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 24px;
        margin-bottom: 40px;
    }
`;

const BenefitCard = styled(Card)`
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: 100%;
    padding: 24px 16px;
    background: white;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    }

    .ant-card-body {
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 20px;
    }

    @media (max-width: 768px) {
        padding: 24px 20px;
    }
`;

const BenefitIcon = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
`;

const BenefitTitle = styled(Title)`
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    margin: 0 !important;
    color: ${colors.text} !important;
`;

const BenefitDescription = styled(Paragraph)`
    font-size: 1rem !important;
    line-height: 1.6 !important;
    color: #666 !important;
    margin: 0 !important;
`;

const CenterButton = styled.div`
    display: flex;
    justify-content: center;
`;

const FAQContainer = styled.div`
    max-width: 800px;
    margin: 8px auto;
`;

const StyledCollapse = styled(Collapse)`
    background: white;
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    
    .ant-collapse-item {
        border: none !important;
        border-bottom: 1px solid #f0f0f0 !important;

        &:last-child {
            border-bottom: none !important;
        }
    }

    .ant-collapse-header {
        font-size: 1.1rem !important;
        font-weight: 600 !important;
        color: ${colors.text} !important;
        padding: 24px !important;
    }

    .ant-collapse-content {
        border-top: none !important;
    }

    .ant-collapse-content-box {
        padding: 0 24px 24px !important;
    }

    .ant-collapse-expand-icon {
        color: ${colors.main} !important;
    }
`;

const StyledPanel = styled(Panel)`
    .ant-collapse-header {
        background: transparent !important;
    }
`;

const FAQAnswer = styled(Paragraph)`
    font-size: 1rem !important;
    line-height: 1.7 !important;
    color: #666 !important;
    margin: 0 !important;
    white-space: pre-line;
`;

const BrnReviewsWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const VideoContainer = styled.div`
    max-width:900px;
    margin: 0 auto;
    background: black;
    border-radius: 32px;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    position: relative;
    padding-bottom: 44%; // 16:9 aspect ratio
`;

const YouTubeEmbed = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 32px;
`;
